/*
 * Kawaconn Assistant design tokens — extracted from the approved Claude Design mock
 * ("Kawaconn Assistant solution design"). All Assistant UI primitives consume these;
 * future assistant features (action cards, digest, …) must reuse them instead of
 * hard-coding colors.
 */

export const KW = {
  /** Accent / CTA */
  teal: '#1fc0da',
  /** Primary brand teal (text accents, links) */
  teal500: '#008aa3',
  /** Headings */
  ink: '#1f2733',
  /** Body text */
  body: '#3d4756',
  /** Muted text */
  muted: '#8190a4',
  /** Hairline borders */
  line: '#eef1f5',
  /** Component borders */
  line2: '#d2d8e2',
  /** Teal tint background */
  soft: '#eefafc',
  /** Neutral tint background */
  soft2: '#f6f8fb',
  /** Border for teal tint surfaces */
  softBorder: '#cdeef5',
  green: '#038951',
  greenBg: '#eefaf3',
  amber: '#b7791f',
  amberBg: '#fff8ec',
  red: '#c9302c',
} as const

export const KW_GRADIENT = `linear-gradient(135deg, ${KW.teal}, ${KW.teal500})`
